import { render } from "./partnersMenu.vue?vue&type=template&id=6350835f"
import script from "./partnersMenu.vue?vue&type=script&lang=js"
export * from "./partnersMenu.vue?vue&type=script&lang=js"

import "./partnersMenu.vue?vue&type=style&index=0&id=6350835f&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__